import React from 'react';
import PropTypes from 'prop-types';
import { TertiaryNavContainer, TertiaryActionables } from './TertiaryNavbar.styles';
import { Breadcrumb } from './partials/Breadcrumb';
import { TertiaryOptions } from './partials/TertiaryOptions';
import { useNavigation } from '../../../../contexts/NavigationCtx';
import { TERTIARY_NAV_LINKS } from '../../../../layouts/DefaultLayout/MainNavContainer/tertiaryNavigationConfig';

function TertiaryNavbar(props) {
  const { routeName } = props;
  const { tertiaryNavigationActionables } = useNavigation();
  const tertiaryNav = TERTIARY_NAV_LINKS.find(({ routeMatches }) => routeMatches.includes(routeName));
  const { routes, breadcrumbs } = tertiaryNav ?? {};

  if (!tertiaryNav) return null;

  return (
    <TertiaryNavContainer>
      <Breadcrumb breadcrumbs={breadcrumbs} routeName={routeName} routes={routes} />
      <TertiaryOptions options={routes} routeName={routeName} />
      <TertiaryActionables>{tertiaryNavigationActionables}</TertiaryActionables>
    </TertiaryNavContainer>
  );
}

TertiaryNavbar.propTypes = {
  mainNav: PropTypes.shape({
    subMenuLinks: PropTypes.arrayOf({})
  }),
  routeName: PropTypes.string
};

TertiaryNavbar.defaultProps = {
  mainNav: {},
  routeName: ''
};

export default TertiaryNavbar;
